import { GET_ALL_PRODUCTS, GET_PRODUCT, FIND_PRODUCT } from '../graphql/queries/getProduct';
import { store } from '../index';
import { SET_ALL_PRODUCTS, SET_PRODUCT, SET_CAPACITY, SET_FILTERS, SET_RESULTS } from './types';
import { history } from '../components/App';

/**
 * Find products
 * 
 * @param {object} client - Apollo client
 * @param {string} query - Search query
 * @param {object} filters - Search filter values
 * @param {boolean} Save - Save product info
 */
export async function FindProduct(client, query="", filters={}, save=null){
    try{

        const response = await client.query({query:FIND_PRODUCT, variables:{query:query, filters:filters}});

        //Save filters info
        await store.dispatch({type:SET_RESULTS, payload:response.data.findProducts});

        //Save all products and filter
        if(save){ 
            await store.dispatch({type:SET_ALL_PRODUCTS, payload:response.data.findProducts.products});
            await store.dispatch({type:SET_FILTERS, payload:response.data.findProducts.filters});
        }
        
        return response;

    }
    catch({graphQLErrors}){
        if(graphQLErrors.length > 0){
            console.error(`${graphQLErrors[0].message} : ${graphQLErrors[0].extensions.response.url}`);
            if(graphQLErrors[0].extensions.response.status === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    }
}


/**
 * Get all products
 * 
 * @param {object} client - Apollo client
 */
export async function GetAllProducts(client){
    try{
        const response = await client.query({query:GET_ALL_PRODUCTS});
        await store.dispatch({type:SET_ALL_PRODUCTS, payload:response.data.allProducts});
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors.length > 0){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    }
}


 /**
 * Get single product
 * 
 *  @param {object} client - Apollo client
 *  @param {string} tourID - Product tour id
 *  @param {string} currency - ISO currenct code
 */
export async function GetProduct(client, tourID, currency){
    try{
        const response = await client.query({query:GET_PRODUCT, variables:{id:tourID, currency:currency} });

        //Save product information
        await store.dispatch({type:SET_PRODUCT, payload:{}});
        await store.dispatch({type:SET_PRODUCT, payload:response.data.getProduct});

        //Save product capacity
        await store.dispatch({type:SET_CAPACITY, payload:response.data.getProduct.productCapacity});

        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors.length > 0){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    }
}